export const options = {
  pageLength: 10,
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: true,
  processing: true,
  scrollX: true,
  fixedColumns: {
    start: 1,
  },
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [5, 10, 20, 40, 80, 160, 200, 500, 1000, 5000, 10000],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6 pb-3'l><'col-sm-12 col-md-6 pb-3'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
};

export const columns = [
  { title: "IMEI", data: "imei", className: "fixed-column-devices-table-bg" },
  { title: "ACTION TYPE", data: "action_type" },
  { title: "USERNAME", data: "username" },
  { title: "From COURSE", data: "from_course" },
  { title: "To COURSE", data: "to_course" },
  { title: "DATE", data: "date" },
  { title: "TIME", data: "time" },
];
